import Component from '../../js/_Component';

const CNAME = 'c-base-form-districts';
let groupId = 10; // ID specific to districts search group in LB

export default class BaseFormDistricts extends Component {

	private searchResults: HTMLElement ;
	private searchInput: HTMLInputElement;
	private searchClearButton: HTMLButtonElement;
	private closeResultListener;
	private inputTimeout;

	constructor(element: HTMLElement) {
		super(element);

		this.searchInput = this.element.querySelector(`.${CNAME}--input-search`);
		this.searchResults = this.element.querySelector(`.${CNAME}--results`);
		//this.searchClearButton = this.element.querySelector(`.${CNAME}--clear-button button`);

		this.inputTimeout = null;
		this.closeResultListener = (e) => { this.closeOnOutsideClick(e); };


		// Add binds to look for changes
		this.searchInput.addEventListener('input', () => this.searchDebounce(this.searchInput.value));
		this.searchInput.addEventListener('focus', () => this.searchDebounce(this.searchInput.value));
		this.searchInput.addEventListener('change', () => this.searchDebounce(this.searchInput.value));

		/*
		this.searchClearButton.addEventListener('click', () => {
			this.emptySearch();
			this.clearResults();
		});
		*/
	}

	searchDebounce(searchString: string) {
		clearTimeout(this.inputTimeout);
		this.inputTimeout = setTimeout(() => this.search(searchString), 500);
	}

	search(searchString: string){

		// If the string is greater than 3, do a search
		if (searchString.length > 3){

			// Fetch results
			fetch('/api/salesforce/salesforce.php?get-school=start', {
				method: 'POST',
				headers: {
					'Accept': 'text/html',
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: `group=${groupId}&options[0][value]=${searchString}`,
			}).then(results => results.text())
			.then(r => this.addResults(r, searchString));
		}
		/*
		else{
			this.addResults("[]", searchString);
		}
		*/
	}

	addResults(results: string, searchString: string){

		// Clear results
		this.clearResults();

		// Add listener to close the menu when clicking outside of it
		document.addEventListener('click', this.closeResultListener);

		// No results found
		if (results == "[]") {
			//let noResults = document.createElement("div") as HTMLElement;
			//noResults.innerHTML = `<div class="no-results">No Results Found: Manually Enter Your School District</div>`;

				let tempButton = document.createElement("button") as HTMLButtonElement;
				let buttonText = `No Results Found - click here to submit a new district`;
				let item = [];
				item.title = 'Not Listed';
				item.custom = searchString;
				tempButton.innerHTML = buttonText;
				tempButton.classList.add("result-button");
				tempButton.dataset["agencyId"] = '';
				tempButton.dataset["city"] = '';
				tempButton.dataset["state"] = '';

				// Listener for what to do when clicking on a result
				tempButton.addEventListener('click', () => this.fillHidden(item, buttonText));

				// Add button to list
				this.searchResults.appendChild(tempButton);


			// Exit
			return;
		}

		// --Prase JSON
		let resultJSON = JSON.parse(results);
		resultJSON.forEach((item) => {
			let tempButton = document.createElement("button") as HTMLButtonElement;
			let buttonText = `${item.title} (${item.city}, ${item.state})`;
			tempButton.innerHTML = buttonText;
			tempButton.classList.add("result-button");
			tempButton.dataset["agencyId"] = item.agencyId;
			tempButton.dataset["city"] = item.city;
			tempButton.dataset["state"] = item.state;

			// Listener for what to do when clicking on a result
			tempButton.addEventListener('click', () => this.fillHidden(item, buttonText));

			// Add button to list
			this.searchResults.appendChild(tempButton);
		});
	}

	clearResults(){
		while (this.searchResults.firstChild) {
			this.searchResults.removeChild(this.searchResults.firstChild);
		}

		// Remove listener for closing the menu when clicking outside
		document.removeEventListener('click', this.closeResultListener);
	}

	emptySearch(){
		this.searchInput.value = "";
	}

	fillHidden(item,buttonText){

        let schoolDistrictInputLabel = document.querySelector('.c-block-affiliation-form--affiliation-custom-district .c-base-form-label') as HTMLInputElement;
        let schoolDistrictInput = document.querySelector('input[name="school-district-input"]') as HTMLInputElement;

        //check if the selected result is either Other or Not Listed
			if(item.title == 'Not Listed') {
					schoolDistrictInputLabel.innerHTML = 'Enter in Your School District';
					schoolDistrictInput.value = item.custom;

					(document.querySelector('input[name="new-school-district"]') as HTMLInputElement).value = 'true';

					// Update hidden inputs
					(this.element.querySelector(`.${CNAME}--input-district-title`) as HTMLInputElement).value = item.custom;
					(this.element.querySelector(`.${CNAME}--input-district-id`) as HTMLInputElement).value = '';
					(this.element.querySelector(`.${CNAME}--input-district-city`) as HTMLInputElement).value = '';
					(this.element.querySelector(`.${CNAME}--input-district-state`) as HTMLInputElement).value = '';
			} else if (item.title == 'Other') {
            schoolDistrictInputLabel.innerHTML = 'Enter in Your School District';
            schoolDistrictInput.value = '';

            // Update hidden inputs
            (this.element.querySelector(`.${CNAME}--input-district-title`) as HTMLInputElement).value = '';
            (this.element.querySelector(`.${CNAME}--input-district-id`) as HTMLInputElement).value = '';
            (this.element.querySelector(`.${CNAME}--input-district-city`) as HTMLInputElement).value = '';
            (this.element.querySelector(`.${CNAME}--input-district-state`) as HTMLInputElement).value = '';
        } else {
            schoolDistrictInputLabel.innerHTML = 'Selected School District';

            // Update school district input if it can be found
            // This is looking out for an input with an ID. It should be present but if not it will exit.
            if (schoolDistrictInput) {
                schoolDistrictInput.value = buttonText;
            }

            // Update hidden inputs
            (this.element.querySelector(`.${CNAME}--input-district-title`) as HTMLInputElement).value = item.title;
            (this.element.querySelector(`.${CNAME}--input-district-id`) as HTMLInputElement).value = item.agencyId;
            (this.element.querySelector(`.${CNAME}--input-district-city`) as HTMLInputElement).value = item.city;
            (this.element.querySelector(`.${CNAME}--input-district-state`) as HTMLInputElement).value = item.state;
        }


		//this.searchInput.value = buttonText; // Old behavior to update the search

		// Clear Results
		this.clearResults();
	}

	closeOnOutsideClick(event: MouseEvent): void {
		const target = event.target as HTMLElement;

		// Only continue if the click target is not a descendent of the menu or button.
		if (target.closest(`.${CNAME}--results`)) {
			return;
		}

		// And clicking on the input.
		if (target.closest(`.${CNAME}--input-search`)) {
			return;
		}


		// Clear results
		this.clearResults();
	}
}


Component.register(BaseFormDistricts, 'BaseFormDistricts');
